module.exports = __webpack_public_path__ + "img/635-7ba170.png";